import { useContext, useMemo } from "react";

import { DispatchContext, DrawerConfig, State, StateContext } from "./reducer";

export function useDrawers(): State {
    const state = useContext(StateContext);
    if (state === undefined) {
        throw new Error("useDrawers must be used within a DrawersProvider");
    }
    return state;
}

export function useDispatchDrawers() {
    const dispatch = useContext(DispatchContext);
    if (dispatch === undefined) {
        throw new Error("useDispatchDrawers must be used within a DrawersProvider");
    }
    return dispatch;
}

/**
 * Get the currently open drawer (if any)
 */
export function useOpenDrawer(): DrawerConfig | null {
    const state = useDrawers();
    return state.openDrawer ? (state.drawerRegistry[state.openDrawer] ?? null) : null;
}

/**
 * Check if a specific drawer is open
 */
export function useIsDrawerOpen(drawerId: string): boolean {
    const state = useDrawers();
    return state.openDrawer === drawerId;
}

/**
 * Check if any drawer is open
 */
export function useHasOpenDrawer(): boolean {
    const state = useDrawers();
    return state.openDrawer !== null;
}

/**
 * Get a specific drawer config by ID
 */
export function useDrawer(drawerId: string): DrawerConfig | undefined {
    const state = useDrawers();
    return useMemo(() => state.drawerRegistry[drawerId], [state.drawerRegistry, drawerId]);
}
